import templateUrl from './app-nav-header.html';
import head from 'lodash/head';
import filter from 'lodash/filter';
import size from 'lodash/size';

export const navHeaderComponent = {
	templateUrl,

	bindings: {
		features: '<'
	},

	controller: class HeaderController {
		constructor($state, $transitions, $window, $timeout, HomeService, ApiService) {
            'ngInject';

            this.$state = $state;
			this.$window = $window;
			this.$timeout = $timeout;
			this.homeService = HomeService;
			this.apiService = ApiService;
        }

		$onInit() {
			this.contactInfo = {};
			this.socialLinks = [];
			this.primaryPhoneNumber = {};
			this.headerImage = "";
			this.showSocialLinks = false;
			this._getSocialLinks();
			this._getContactDetails();
			this._getHeaderLogo();
			
			this.showStickyHeader = false;

			this.window = angular.element(this.$window);
			
			this.window.bind('scroll', _ => {
				let window = head(this.window);
				let pageYOffset = window.pageYOffset;
				let innerWidth = window.innerWidth;
				this.onScrollChange(pageYOffset, innerWidth);
			});
		}

		onSearch(searchKey) {
			this.$state.go('SearchResults', {
				searchKey
			});
		}

		onScrollChange(pageYOffset, innerWidth) {
				this.$timeout(_ => {
				this.showStickyHeader = ((pageYOffset >= 420 && innerWidth > 768) || (pageYOffset >= 250 && innerWidth <= 768)) ? true : false;
			});
		}

		//*****************************************************PRIVATE METHODS********************************** */
		
		_getSocialLinks() {
			this.homeService.getSocialLinks()
				.then(socialLinks => {
					this.socialLinks = socialLinks;
					this.showSocialLinks = this._checkIfAnySocialLinkExist(this.socialLinks);
				});
		}

		_getContactDetails() {
			this.homeService.getContactInfoDetails()
				.then(details => {
					this.contactInfo = details;
					this.primaryPhoneNumber = head(details.phone);
				});
		}

		_getHeaderLogo() {
			this.homeService.getFooterLogo()
				.then(({image}) => {
					this.headerImage = this._getImage(image);
				});
		}

		_getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}

		_checkIfAnySocialLinkExist(socialLinks) {
			const socialLinkWithUrlExist = filter(socialLinks, ({url}) => url !== "");
			return size(socialLinkWithUrlExist) > 0 ? true : false;
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-header.component.js